import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PaddingPosition } from '../../../../common/directives';
import { SlideBucketCard } from '../../../../common/models/slide-bucket-card.model';

@Component({
    selector: 'lib-bucket-card',
    templateUrl: './bucket-card.component.html',
    styleUrls: ['./bucket-card.component.scss'],
    standalone: false
})
export class BucketCardComponent {

  @Input() card!: SlideBucketCard;
  @Input() spacing!: PaddingPosition;
  @Input() cardsCount?: number;
  @Input() showEditButton = false;
  @Input() showErrors = false;
  @Input() isTranslation = false;
  @Input() slide: any;

  @Output() edit: EventEmitter<void> = new EventEmitter();
  @Output() remove: EventEmitter<void> = new EventEmitter();

  public emitEdit(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.edit.emit();
  }

  public emitRemove(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.remove.emit();
  }

}
